<script setup>
import { ref } from "vue";
//import Conf from '@/Components/MainGlobal.vue';
import CardBoxModal from "@/Components/CardBoxModal.vue";
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeCheckbox from '@/Components/Checkbox.vue';
import { Head, Link, useForm} from '@inertiajs/inertia-vue3';
//import BreezeApplicationLogo from '@/Components/ApplicationLogo.vue';
import BreezeApplicationLogoFull from '@/Components/ApplicationLogoFull.vue';
import BreezeDropdown from '@/Components/Dropdown.vue';
import BreezeDropdownLink from '@/Components/DropdownLink.vue';
import BaseButton from "@/Components/BaseButton.vue";
import Footer from '@/Components/Footer.vue';
import { Inertia } from '@inertiajs/inertia';
import {
    mdiCog,
    mdiCellphoneArrowDown,
    mdiMonitorArrowDown
} from "@mdi/js";

/* const props = defineProps({
    canLogin: Boolean,
    canRegister: Boolean,
    laravelVersion: String,
    phpVersion: String,
    appVersion: String
    //connstantes: Array
}) */

// LRR
//const confGlobal = props.connstantes
/*const confGlobal = ref([])
onMounted(() => {
  let url = '/constante/global';
  axios.get(url).then(function (response) {
      var respuesta = response.data;
      confGlobal.value = respuesta.constantes;
      //console.log(me.constante);
    }).catch(function (error) {
        console.log(error);
  });
});
*/
//console.log( props.connstantes )

/* const form = useForm({
    email: '',
    nombre: '',
    phone: '',
    comment: '',
    recibirinfo: false
}); */
const isModalActive = ref(false);

</script>

<template>
    <Head title="Offline" />

    <!--Nav-->
    <header>
        <nav id="header" class="sticky w-full bg-white border-b border-gray-200">
        <div class="w-full container mx-auto flex flex-wrap items-center justify-between mt-0 py-2">
            <div class="pl-4 flex items-center">
                <a class="toggleColour text-white no-underline hover:no-underline font-bold text-1xl lg:text-2xl"
                    href="#">
                    <!--Icon from: http://www.potlabicons.com/ -->
                    <BreezeApplicationLogoFull class="block logo-full-h w-auto" />
                </a>
            </div>
                
                
            </div>
            <hr class="border-b border-gray-100 opacity-25 my-0 py-0" />
        </nav>
    </header>

    <!--Hero-->
    <section>
        <div class="md:h-[calc(100vh_-_91px)] h-[calc(100vh_-_67px)]">
            <div class="mx-auto px-4 sm:px-6 lg:px-8 h-[calc(100%_-_40px)]">
                <div class="grid md:grid-cols-2 grid-cols-1 h-full content-center">
                    <div class="col-span-1 grid content-center h-full">
                        
                        <h2 class="md:text-3xl text-base mb-4">
                            No estás conectado a una red con internet, 
                        </h2>
                        <!-- <BaseButton
                        color="info"
                        label="Click aquí para intentar otra vez"
                        :inertiahref="route('login')"
                        /> -->
                        
                    </div>
                    <div class="col-span-1 grid content-center justify-center h-full">
                        <div class="md:mt-0 mt-4 w-full">
                            <img class="md:max-w-full md:max-h-full max-h-[280px]" src="/offline/youareoffline.png" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="fixed bottom-0 bg-gray-100 w-full z-40">
                <div class="w-full flex justify-center">
                    <div class="container mx-auto">
                        <div class="grid grid-cols-1 justify-center py-2">
                            <div class="text-center">
                                <p class="text-sm md:text-base">&copy; Unens Education <a
                                        href="https://unens.com/" target="_blank"> - unens.com</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- <footer class="bg-white rounded-lg shadow m-4 dark:bg-gray-800">
        <div class="text-center w-full mx-auto max-w-screen-xl p-4 justify-center">
            <span class="text-sm text-gray-500 sm:text-center dark:text-gray-400">© 2023 <a href="https://unens.com/" target="_blank" class="hover:underline">Unens.com</a>. Unens Edu 2.0.0
            </span>
        </div>
    </footer> -->
    
</template>

<style scoped>
    .gradient {
        background: linear-gradient(90deg, #d53369 0%, #daae51 100%);
    }
    .bg-gray-100 {
        background-color: #f7fafc;
        background-color: rgba(247, 250, 252, var(--tw-bg-opacity));
    }

    .border-gray-200 {
        border-color: #edf2f7;
        border-color: rgba(237, 242, 247, var(--tw-border-opacity));
    }

    .text-gray-400 {
        color: #cbd5e0;
        color: rgba(203, 213, 224, var(--tw-text-opacity));
    }

    .text-gray-500 {
        color: #a0aec0;
        color: rgba(160, 174, 192, var(--tw-text-opacity));
    }

    .text-gray-600 {
        color: #718096;
        color: rgba(113, 128, 150, var(--tw-text-opacity));
    }

    .text-gray-700 {
        color: #4a5568;
        color: rgba(74, 85, 104, var(--tw-text-opacity));
    }

    .text-gray-900 {
        color: #1a202c;
        color: rgba(26, 32, 44, var(--tw-text-opacity));
    }

    @media (prefers-color-scheme: dark) {
        .dark\:bg-gray-800 {
            background-color: #2d3748;
            background-color: rgba(45, 55, 72, var(--tw-bg-opacity));
        }

        .dark\:bg-gray-900 {
            background-color: #1a202c;
            background-color: rgba(26, 32, 44, var(--tw-bg-opacity));
        }

        .dark\:border-gray-700 {
            border-color: #4a5568;
            border-color: rgba(74, 85, 104, var(--tw-border-opacity));
        }

        .dark\:text-white {
            color: #fff;
            color: rgba(255, 255, 255, var(--tw-text-opacity));
        }

        .dark\:text-gray-400 {
            color: #cbd5e0;
            color: rgba(203, 213, 224, var(--tw-text-opacity));
        }
    }
</style>
